angular.module('app.agenda').factory('agendaRecebivelFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {
    var _apiName = 'AgendaRecebivel';

    var motivosLancamentos = {};
    var agendaDados = {}

    var _listarAgendas = function (options, dataInicio, dataTermino, documentoFederal, nomeRazaoSocial, nomeParceiro, nroProposta) {

        var dto = options.data;
        dto.parms = [];
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "DocumentoFederal", "value": documentoFederal });
        dto.parms.push({ "name": "NomeRazaoSocial", "value": nomeRazaoSocial });
        dto.parms.push({ "name": "NomeParceiro", "value": nomeParceiro });
        dto.parms.push({ "name": "NroProposta", "value": nroProposta });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListaAgendasMP', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _listarHistoricoParametrosAgenda = function (options, codigoAgenda) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoAgenda", "value": codigoAgenda });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListaHistoricoParametrosAgenda', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _consultarParametrosAgenda = function (codigoAgenda) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoAgenda", "value": codigoAgenda });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ConsultaParametrosAgenda', dto);
    };

    var _salvarParametrosAgenda = function (parametrosAgenda) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/SalvaParametrosAgenda', parametrosAgenda);
    };

    var _listarParametrosAgendas = function (options, listaPropostas) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "Propostas", "value": listaPropostas.toString() });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListaParametrosAgendas', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _salvarParametrosAgendas = function (novosParametros, codigosParametrosAgendas) {

        var dto = novosParametros;
        dto.CodigosParametrosPropostas = codigosParametrosAgendas;

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/SalvaParametrosAgendas', dto);
    };

    var _detalhesAgenda = function (options, codigoAgenda) {
        var dto = { CodigoAgenda: codigoAgenda };
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/DetalhesAgenda', dto).then(function (response) {
            _setAgendaDados(response.data.AgendaDados)
            _setMotivosLancamentos(response.data.MotivosLancamento)
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _setMotivosLancamentos = function (listaMotivosLancamentos) {
        motivosLancamentos = Object.entries(listaMotivosLancamentos).map(([key, value]) => ({
            value: key,
            text: value
        }));
    }

    var _motivosLancamentos = function () {
        return motivosLancamentos;
    }

    var _setAgendaDados = function (dados) {
        agendaDados = dados
    }

    var _getDadosAgendaAtual = function () {
        return agendaDados;
    }

    var _extratoParcela = function (options, codigoParcela) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoParcela", "value": codigoParcela });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ExtratoParcela', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _prorrogarVencimentoParcela = function (codigoParcela, novoVencimento, motivoAlteracao) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoParcela", "value": codigoParcela });
        dto.parms.push({ "name": "NovoVencimento", "value": novoVencimento });
        dto.parms.push({ "name": "MotivoAlteracao", "value": motivoAlteracao });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ProrrogaVencimentoParcela', dto);
    };

    var _acrescimoAbatimentoParcela = function (codigoParcela, vlrLancamento, dtLancamento, tipoLancamento, descLancamento) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoParcela", "value": codigoParcela });
        dto.parms.push({ "name": "VlrLancamento", "value": vlrLancamento });
        dto.parms.push({ "name": "DtLancamento", "value": dtLancamento });
        dto.parms.push({ "name": "TipoLancamento", "value": tipoLancamento });
        dto.parms.push({ "name": "DescLancamento", "value": descLancamento });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AcrescimoAbatimentoParcela', dto);
    };

    var _lancamentoManualParcela = function (codigoParcela, vlrLancamento, dtLancamento, vlrDesconto, descLancamento, motivoLancamento) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoParcela", "value": codigoParcela });
        dto.parms.push({ "name": "VlrLancamento", "value": vlrLancamento });
        dto.parms.push({ "name": "DtLancamento", "value": dtLancamento });
        dto.parms.push({ "name": "VlrDesconto", "value": vlrDesconto });
        dto.parms.push({ "name": "DescLancamento", "value": descLancamento });
        dto.parms.push({ "name": "MotivoLancamento", "value": motivoLancamento });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/LancamentoManualParcela', dto);
    };

    var _baixaAgenda = function (codigoAgenda, calculoParcelas, dtPagamento, descBaixa, motivoLancamento) {
        var dto = {
            CodigoAgenda: codigoAgenda,
            CalculoParcelas: calculoParcelas,
            DtPagamento: dtPagamento,
            DescBaixa: descBaixa,
            MotivoLancamento: motivoLancamento
        };

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/BaixarAgenda', dto);
    }

    var _calcularValoresParcelas = function (codigosParcelas, dtVencimento, boletoLiquidacao = false) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigosParcelas", "value": codigosParcelas });
        dto.parms.push({ "name": "DtVencimento", "value": dtVencimento });
        dto.parms.push({ "name": "BoletoLiquidacao", "value": boletoLiquidacao });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/CalculaValoresParcelas', dto);
    };


    var _calcularParcelasBaixaAgenda = function (options, codigoAgenda, dtPagamento) {
        var dto = {
            CodigoAgenda: codigoAgenda,
            DtPagamento: dtPagamento
        };

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/CalcularParcelasBaixaAgenda', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });;
    }

    var _consultaParamBancoParaCarteiraBoleto = function (codigoAgenda) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoAgenda", "value": codigoAgenda });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ConsultaParamBancoParaCarteiraBoleto', dto);
    };

    var _gerarBoleto = function (codigosParcelas, dtVencimento, descLiquidacao, motivoLancamento, codigoParamBanco, codigoIntegracao, vlrBoletoParcial, vlrDesconto) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigosParcelas", "value": codigosParcelas });
        dto.parms.push({ "name": "DtVencimento", "value": dtVencimento });
        dto.parms.push({ "name": "DescLiquidacao", "value": descLiquidacao });
        dto.parms.push({ "name": "MotivoLancamento", "value": motivoLancamento });
        dto.parms.push({ "name": "CodigoParamBanco", "value": codigoParamBanco });
        dto.parms.push({ "name": "CodigoIntegracao", "value": codigoIntegracao });
        dto.parms.push({ "name": "VlrBoletoParcial", "value": vlrBoletoParcial });
        dto.parms.push({ "name": "VlrDesconto", "value": vlrDesconto });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/GeraBoleto', dto);
    };

    var _gerarPixCobranca = function (codigosParcelas, dtVencimento, descLiquidacao, motivoLancamento, vlrPixParcial, vlrDesconto) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigosParcelas", "value": codigosParcelas });
        dto.parms.push({ "name": "DtVencimento", "value": dtVencimento });
        dto.parms.push({ "name": "DescLiquidacao", "value": descLiquidacao });
        dto.parms.push({ "name": "MotivoLancamento", "value": motivoLancamento });
        dto.parms.push({ "name": "VlrCobrancaParcial", "value": vlrPixParcial });
        dto.parms.push({ "name": "VlrDesconto", "value": vlrDesconto });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/GerarPixCobranca', dto);
    };

    var _cancelarBoletos = function (codigosBoletos) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigosBoletos", "value": codigosBoletos });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/CancelaBoletos', dto);
    };

    var _cancelarPixCobranca = function (codigoCobranca, codigoAgenda) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoCobranca", "value": codigoCobranca });
        dto.parms.push({ "name": "CodigoAgenda", "value": codigoAgenda });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/CancelarPixCobranca', dto);
    }

    var _consultarCobranca = function (codigoLiquidacao, codigoBoleto, codigoPixCobranca) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoLiquidacao", "value": codigoLiquidacao });
        dto.parms.push({ "name": "CodigoBoleto", "value": codigoBoleto });
        dto.parms.push({ "name": "CodigoPixCobranca", "value": codigoPixCobranca });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ConsultaBoleto', dto);
    };

    var _listarBoletos = function (options, codigoAgenda, nroProposta, nroBoleto, dtInicio, dtTermino, docFederalParceiro) {

        var dto = options.data;
        dto.parms = [];
        dto.parms.push({ "name": "CodigoAgenda", "value": codigoAgenda });
        dto.parms.push({ "name": "NroProposta", "value": nroProposta });
        dto.parms.push({ "name": "NroBoleto", "value": nroBoleto });
        dto.parms.push({ "name": "DtInicio", "value": dtInicio });
        dto.parms.push({ "name": "DtTermino", "value": dtTermino });
        dto.parms.push({ "name": "DocFederalParceiro", "value": docFederalParceiro });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListaBoletosMP', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _listarCobrancas = function (options, codigoAgenda, nroProposta, nroBoleto, dtInicio, dtTermino, docFederalParceiro) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoAgenda", "value": codigoAgenda });
        dto.parms.push({ "name": "NroProposta", "value": nroProposta });
        dto.parms.push({ "name": "NroBoleto", "value": nroBoleto });
        dto.parms.push({ "name": "DtInicio", "value": dtInicio });
        dto.parms.push({ "name": "DtTermino", "value": dtTermino });
        dto.parms.push({ "name": "DocFederalParceiro", "value": docFederalParceiro });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListarCobrancas', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _detalhesCobranca = function (options, codigoLiquidacao) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoLiquidacao", "value": codigoLiquidacao });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/DetalhesCobranca', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _cancelarAgenda = function (codigoAgenda) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoAgenda", "value": codigoAgenda });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/CancelaAgenda', dto);
    };

    var _reabrirAgenda = function (codigoAgenda) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoAgenda", "value": codigoAgenda });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ReaberturaAgenda', dto);
    };

    var _calcularParcelasAnaliseProposta = function (codigoProposta) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoProposta", "value": codigoProposta });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/CalculaParcelasAnaliseProposta', dto);
    };

    var _estornarLancamento = function (codigoLancamento, motivoEstorno, codigoCorrelacaoLancamentos) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoLancamento", "value": codigoLancamento });
        dto.parms.push({ "name": "MotivoEstorno", "value": motivoEstorno });
        dto.parms.push({ "name": "CodigoCorrelacaoLancamentos", "value": codigoCorrelacaoLancamentos });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/EstornarLancamento', dto);
    };

    var _consultarEstornoLancamento = function (codigoEstorno) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoEstorno", "value": codigoEstorno });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ConsultarEstornoLancamento', dto);
    }

    var factory = {};

    factory.listarAgendas = _listarAgendas;
    factory.listarHistoricoParametrosAgenda = _listarHistoricoParametrosAgenda;
    factory.consultarParametrosAgenda = _consultarParametrosAgenda;
    factory.salvarParametrosAgenda = _salvarParametrosAgenda;
    factory.salvarParametrosAgendas = _salvarParametrosAgendas;
    factory.listarParametrosAgendas = _listarParametrosAgendas;
    factory.detalhesAgenda = _detalhesAgenda;
    factory.setMotivosLancamentos = _setMotivosLancamentos;
    factory.motivosLancamentos = _motivosLancamentos;
    factory.setAgendaDados = _setAgendaDados;
    factory.getDadosAgendaAtual = _getDadosAgendaAtual;
    factory.extratoParcela = _extratoParcela;
    factory.prorrogarVencimentoParcela = _prorrogarVencimentoParcela;
    factory.acrescimoAbatimentoParcela = _acrescimoAbatimentoParcela;
    factory.lancamentoManualParcela = _lancamentoManualParcela;
    factory.calcularValoresParcelas = _calcularValoresParcelas;
    factory.consultaParamBancoParaCarteiraBoleto = _consultaParamBancoParaCarteiraBoleto;
    factory.gerarBoleto = _gerarBoleto;
    factory.gerarPixCobranca = _gerarPixCobranca;
    factory.cancelarBoletos = _cancelarBoletos;
    factory.cancelarPixCobranca = _cancelarPixCobranca;
    factory.consultarCobranca = _consultarCobranca;
    factory.listarBoletos = _listarBoletos;
    factory.listarCobrancas = _listarCobrancas;
    factory.detalhesCobranca = _detalhesCobranca;
    factory.cancelarAgenda = _cancelarAgenda;
    factory.reabrirAgenda = _reabrirAgenda;
    factory.calcularParcelasAnaliseProposta = _calcularParcelasAnaliseProposta;
    factory.estornarLancamento = _estornarLancamento;
    factory.consultarEstornoLancamento = _consultarEstornoLancamento;
    factory.baixaAgenda = _baixaAgenda;
    factory.calcularParcelasBaixaAgenda = _calcularParcelasBaixaAgenda;

    return factory;

}]);